import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import datePicker from "vue-bootstrap-datetimepicker"
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css"

Vue.use(BootstrapVue)
